// @flow
import slugify from 'slugify';

export const normaliseSportShortName = (shortName: string): string => {
  const slug = slugify(shortName, { lower: true });

  return slug === 'nbl-pre' ? 'nbl' : slug;
};

export const shouldUseAverage = (sportSlug: string, sportShortName: string): boolean =>
  sportSlug === 'football' || sportShortName === 'nbl';
